import React,{useEffect} from "react";
import { Routes, Route } from 'react-router-dom';

import SalesDashboard from './../Pages/Sales/Dashboard';
//import SalesLeads from './../Pages/Sales/Leads/Lead';
//import SalesLeadEdit from './../Pages/Sales/Leads/EditLead';
import SalesCampaigns from "./../Pages/Sales/Campaigns/Campaign";
import SalesCampaignReport from "./../Pages/Sales/Campaigns/CampaignReport";
import Teams from "./../Pages/Sales/Teams";
import Report from "./../Pages/Sales/Reports/Report";

import SalesLeadFilter from "./../Pages/Sales/LeadFilter";
import NotificationFilterDataList from "./../Pages/Sales/NotificationFilter";

import LeadProfile from './../Pages/Sales/Leads/LeadProfile';

import SalesActivityLogs from './../Pages/Sales/ActivityLogs/Logs';

//import SalesNotifications from './../Pages/Sales/Notifications/Notification';
import SalesLeadAdd from './../Pages/Sales/LeadAdd';
import SalesLeadProfile from './../Pages/Sales/LeadProfile';

//import AuthChecker from './../Pages/AuthenticationChecker';

//import NotFound from './../Pages/NotFound';

const Sales = [
    {
        path: "sales/dashboard",
        element: <SalesDashboard />,
    },
    {
        path: "sales/campaigns",
        element: <SalesCampaigns />,
    },
    {
        path: "sales/campaign-report/:campaignid",
        element: <SalesCampaignReport />,
    },
    {
        path: "sales/teams",
        element: <Teams />,
    },
    {
        path: "sales/report",
        element: <Report />,
    },
    {
        path: "sales/activity-logs",
        element: <SalesActivityLogs />,
    },
    {
        path: "sales/lead/add",
        element: <SalesLeadAdd />,
    },
    {
        path: "sales/lead/profile/:leadid",
        element: <SalesLeadProfile />,
    },
    {
        path: "sales/lead/:filtertype", 
        element: <SalesLeadFilter />,
    },
    {
        path: "sales/lead-profile/:leadid", 
        element: <LeadProfile />,
    },
    {
        path: "sales/notification/:filtertype", 
        element: <NotificationFilterDataList />,
    },
    

];



    /*useEffect(()=>{
        console.log('I am in sales routes');
    });*/

    /*return(
        <Routes>

                <Route element={<AuthChecker />} />
                <Route path="sales/dashboard" element={<SalesDashboard />} />

                <Route path="sales/leads" element={<SalesLeads />} />
                <Route path="sales/lead/:leadid/edit" element={<SalesLeadEdit />} />

                <Route path="sales/activity-logs" element={<SalesActivityLogs />} />

                <Route path="sales/notifications" element={<SalesNotifications />} />

                <Route path="*" element={<SalesDashboard />} />
        </Routes>
    );*/


export default Sales;